import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { myTestApi } from '../../utils/myTestApi';
import { clearMustChangePassword, getSchool, homePath } from '../../utils/schoolSession';

/**
 * First sign-in with the password the school gave out. The API refuses every
 * other call (428) until the account has a password only its owner knows,
 * so this page is where PrivateRoute sends the student.
 *
 * The rules for a new password are the API's (User::password_problem); its
 * sentence is shown as it is when one is broken.
 */
const SetPassword: React.FC = () => {
  const navigate = useNavigate();
  const school = getSchool();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (next !== again) {
      setError('The two new passwords are not the same.');
      return;
    }
    setBusy(true);
    try {
      await myTestApi.changePassword(current, next);
      clearMustChangePassword();
      navigate(homePath(), { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: 480 }}>
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <h4 className="mb-2">Set your own password</h4>
          <p className="text-muted small mb-4">
            {school ? `${school.name} gave you a temporary password.` : 'You signed in with a temporary password.'} Choose one that only you know
            before you continue.
          </p>
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <form onSubmit={submit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="sp-current">Temporary password</label>
              <input id="sp-current" type="password" className="form-control" value={current} onChange={e => setCurrent(e.target.value)} required autoComplete="current-password" />
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="sp-new">New password</label>
              <input id="sp-new" type="password" className="form-control" value={next} onChange={e => setNext(e.target.value)} required autoComplete="new-password" />
            </div>
            <div className="mb-4">
              <label className="form-label" htmlFor="sp-again">New password again</label>
              <input id="sp-again" type="password" className="form-control" value={again} onChange={e => setAgain(e.target.value)} required autoComplete="new-password" />
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={busy}>
              {busy ? 'Saving…' : 'Save and continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
